import { Chip } from "@mui/material";
import StripeIcon from "assets/icons/StripeIcon";
import MainTheme from "assets/theme/MainTheme";
import {
    getSubscriptionStatusBackgroundColor,
    getSubscriptionStatusLabel,
} from "utils/subscriptionStatus";

const NotAvailableData = () => {
    return "";
};

export const companiesColumnHeaders = [
    {
        field: "id",
        headerName: "ID",
        width: 80,
    },
    {
        field: "companyName",
        headerName: "Company",
        sortable: false,
        width: 200,
    },
    {
        field: "subscriptionStatus",
        headerName: "Sub. Status",
        sortable: false,
        width: 150,
        renderCell: (params) => {
            const value = params.value;
            if (!value) return <NotAvailableData />;

            return (
                <Chip
                    size="small"
                    label={getSubscriptionStatusLabel(value)}
                    variant="filled"
                    sx={{
                        backgroundColor:
                            getSubscriptionStatusBackgroundColor(value),
                        color: "#000",
                    }}
                />
            );
        },
    },
    {
        field: "packageName",
        headerName: "Sub. package",
        sortable: false,
        width: 160,
        renderCell: (params) =>
            params.row?.package?.name ? (
                params.row.package.name
            ) : (
                <NotAvailableData />
            ),
    },
    {
        field: "subscriptionSource",
        headerName: "Sub. source",
        sortable: false,
        width: 160,
        renderCell: (params) => {
            const value = params.value;
            if (!value) return <NotAvailableData />;

            if (value === "stripe") {
                return (
                    <StripeIcon
                        fill={MainTheme.palette.grey[500]}
                        style={{ width: "3rem", height: "auto" }}
                    />
                );
            }

            if (value === "manual") {
                return (
                    <Chip
                        style={{
                            backgroundColor: "#f3e5f5",
                        }}
                        label="MANUAL"
                    />
                );
            }

            return <NotAvailableData />;
        },
    },
    {
        field: "jobPostCredits",
        headerName: "Job slots",
        sortable: false,
        width: 100,
        renderCell: (params) =>
            params.value ? params.value : <NotAvailableData />,
    },
    {
        field: "attCredits",
        headerName: "Linq credits",
        sortable: false,
        width: 100,
        renderCell: (params) =>
            params.value ? params.value : <NotAvailableData />,
    },
    {
        field: "startDate",
        headerName: "Start Date",
        sortable: false,
        width: 170,
        valueGetter: (params) => {
            const rawDate = params.row?.startDate?.iso8601;
            return rawDate
                ? new Date(rawDate).toLocaleDateString("en-GB")
                : null;
        },
        renderCell: (params) =>
            params.value ? params.value : <NotAvailableData />,
    },
    {
        field: "endDate",
        headerName: "End Date",
        sortable: false,
        width: 170,
        valueGetter: (params) => {
            const rawDate = params.row?.endDate?.iso8601;
            return rawDate
                ? new Date(rawDate).toLocaleDateString("en-GB")
                : null;
        },
        renderCell: (params) =>
            params.value ? params.value : <NotAvailableData />,
    },
];

export default companiesColumnHeaders;
